<template>
  <div class="pt-2">
    <template
      v-if="
        dc_key_info.length > 0 ||
        (standard_mode !== 'GRI' &&
          selected_lv2 &&
          $route.path !== '/mg_charts' &&
          $route.path !== '/write_report/story_board')
      "
    >
      <div class="pt-2 pb-4">
        <h5 class="f-110 tail-line-dark">
          <span v-if="dc_key_info.length > 0">
            {{ dc_key_info[0]['name'] }} > {{ dc_key_info[1]['name'] }} 지표에 차트 추가
          </span>
        </h5>
      </div>
    </template>

    <div class="w-100 d-flex justify-content-between">
      <b-form-group label-cols="12" label-for="per-page-select" variant="info">
        <b-form-select id="per-page-select" v-model="perPage" :options="[5, 10, 15, 20]" />
      </b-form-group>
      <div class="d-flex align-items-center flex-wrap">
        <b-form-group label-cols="12" label-for="sort-select" variant="info" class="mr-1 mb-3">
          <b-form-select
            id="sort-select"
            v-model="sortOption"
            :options="sortOptions"
            @change="handleSortChange"
          />
        </b-form-group>

        <b-button
          v-b-tooltip.hover
          variant="white-border"
          class="p-1 mr-3"
          :title="sortDirection === 'asc' ? '내림차순으로 정렬' : '오름차순으로 정렬'"
          @click="toggleSortDirection"
        >
          <b-icon :icon="sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'" />
        </b-button>
        <b-form-group label-cols="12" label-for="search-input">
          <b-form-input
            id="search-input"
            v-model="searchQuery"
            placeholder="검색어를 입력하세요..."
            align="right"
          />
        </b-form-group>
      </div>
    </div>

    <b-table
      v-if="chart_data"
      class="bor-table mb-45"
      :fields="chart_field_with_duplicate"
      :items="paginatedChartData"
      responsive
      hover
    >
      <template #cell(chart_id)="row">
        {{ row.index + 1 }}
      </template>

      <template #cell(choice)="row">
        <b-form-group v-if="editing_gri_code != ''">
          <b-form-checkbox-group v-model="selected_checkbox_chart_list">
            <b-form-checkbox :value="row.item.chart_id" />
          </b-form-checkbox-group>
        </b-form-group>

        <b-form-group
          v-else-if="dc_key_info.length > 0 || (standard_mode !== 'GRI' && selected_lv2 !== null)"
        >
          <b-form-radio v-model="selected_radio_chart_id" :value="row.item.chart_id" />
        </b-form-group>
      </template>

      <template #cell(time_stamp)="row">
        <p class="mb-0 f-90">{{ row.item.time_stamp }}</p>
      </template>

      <template #cell(view_chart)="row">
        <b-button variant="icon-txt-border" size="sm" @click="row.toggleDetails">
          <template v-if="row.detailsShowing">
            <b-icon icon="fullscreen-exit" />
          </template>
          <template v-else>
            <b-icon icon="fullscreen" />
          </template>
        </b-button>
      </template>

      <template #cell(edit_chart)="row">
        <b-button variant="icon-txt-border" size="sm" @click="editSelectedChart(row)">
          <b-icon icon="vector-pen" />
        </b-button>
      </template>

      <template #cell(dup_chart)="row">
        <b-button
          v-b-tooltip.hover
          variant="icon-txt-border"
          size="sm"
          title="이 차트 복사하기"
          @click="openDuplicateModal(row.item)"
        >
          <b-icon icon="files" />
        </b-button>
      </template>

      <template #cell(mng_chart)="row">
        <b-button variant="icon-txt-border" size="sm" @click="manageSelectedChart(row)">
          <b-icon icon="gear" />
        </b-button>
      </template>

      <template #cell(indicators)="row">
        <div v-if="storyboard_linked_indicators[row.item.chart_id]">
          <span
            v-for="(item1, index1) in storyboard_linked_indicators[row.item.chart_id]"
            :key="`story_board_${index1}`"
          >
            <a class="cursor" @click="goHash(item1, 'STORY_BOARD')">
              웹 보고서 {{ item1?.sb_toc_lv1?.name }} >
              {{ item1?.sb_toc_lv2?.name }}
            </a>
            <br />
          </span>
        </div>

        <div v-if="gri_linked_indicators[row.item.chart_id]">
          <span
            v-for="(item1, index1) in gri_linked_indicators[row.item.chart_id]"
            :key="`gri_${index1}`"
          >
            <a class="cursor" @click="goHash(item1, 'GRI')"> GRI {{ item1 }} </a>
            <br />
          </span>
        </div>

        <div v-if="sasb_linked_indicators[row.item.chart_id]">
          <span
            v-for="(item1, index1) in sasb_linked_indicators[row.item.chart_id]"
            :key="`sasb_${index1}`"
          >
            <a class="cursor" @click="goHash(item1, 'SASB')"> SASB {{ item1 }} </a>
            <br />
          </span>
        </div>

        <div v-if="tcfd_linked_indicators[row.item.chart_id]">
          <span
            v-for="(item1, index1) in tcfd_linked_indicators[row.item.chart_id]"
            :key="`tcfd_${index1}`"
          >
            <a class="cursor" @click="goHash(item1, 'TCFD')"> TCFD {{ item1 }} </a>
            <br />
          </span>
        </div>

        <span
          v-for="(item, index) in chart_linked_indicators[row.item.chart_id]"
          :key="`gri_${index}`"
        >
          <a class="cursor" @click="goHash(item, 'DATA_CENTER')">
            Data Center {{ item['lv1_info']['name'] }} >
            {{ item['lv2_info']['name'] }}
          </a>
          <br />
        </span>
      </template>

      <template #row-details="row">
        <transition name="fade">
          <b-card>
            <ChartCanvasViewer :viewer_mode="true" :chart_id="row.item.chart_id" />
          </b-card>
        </transition>
      </template>
    </b-table>

    <b-card
      class="make-new-card text-center cursor bg-transparent mb-4"
      @click="addOrEditChartCase()"
    >
      <fa icon="plus" class="mr-2" />새 차트 생성
    </b-card>

    <b-pagination
      v-model="currentPage"
      :total-rows="filteredChartData.length"
      :per-page="perPage"
      aria-controls="chart-table"
      align="fill"
    />

    <b-modal
      ref="edit-chart-case"
      title="차트 사례"
      hide-footer
      size="xl"
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="closeEditChartModal"
    >
      <DefaultChart v-if="show_edit_chart" @closeEditChartModal="closeEditChartModal" />
      <ManageChart v-if="show_manage_chart" @closeEditChartModal="closeEditChartModal" />
    </b-modal>

    <DuplicateItemModal
      ref="duplicateModal"
      modal-id="chart-case-list-duplicate-modal"
      title="차트 사본 만들기"
      :source-title="duplicate_source ? duplicate_source.title || duplicate_source.label : ''"
      :validator="validateDuplicateTitle"
      @confirm="confirmDuplicate"
    />

    <div v-if="editing_gri_code !== ''" class="pt-4 pb-3">
      <b-button variant="teal" class="mr-3" @click="applyChart">선택한 차트 적용</b-button>
      <b-button @click="closeEditChartModal">취소</b-button>
    </div>
    <div
      v-else-if="dc_key_info.length > 0 || (standard_mode !== 'GRI' && selected_lv2)"
      class="pt-4 pb-3"
    >
      <b-button variant="teal" class="mr-3" @click="applyChartFromDC">선택한 차트 적용</b-button>
      <b-button @click="closeEditChartModal">취소</b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { gri_mixin } from '@/components/writing_report/write_report_subs/gri_mixin';
import ChartCanvasViewer from '@/components/writing_report/chart_subs/ChartCanvasViewer.vue';
import DefaultChart from '@/components/writing_report/chart_subs/DefaultChart';
import ManageChart from '@/components/writing_report/chart_subs/ManageChart';
import DuplicateItemModal from '@/components/writing_report/util/DuplicateItemModal.vue';
import { nextDuplicateName } from '@/components/writing_report/util/duplicate-name';

export default {
  name: 'ChartCaseList',
  components: {
    DefaultChart: DefaultChart,
    ManageChart: ManageChart,
    ChartCanvasViewer: ChartCanvasViewer,
    DuplicateItemModal
  },
  mixins: [gri_mixin],
  props: {
    dc_key_info: { type: Array, default: () => [] },
    editing_mode: { type: Boolean, default: () => false },
    selected_chart_list: { type: Array, default: () => [] },
    selected_mng_chart_id: { type: Number, default: null },
    sb_disclosure_id: { type: Number, default: () => null }
  },
  data() {
    return {
      selected_radio_chart_id: this.selected_mng_chart_id,
      selected_checkbox_chart_list: [],
      initial_checkbox_chart_list: this.selected_chart_list, // state에 넣은 값을 초기값으로 넣어주기
      show_edit_chart: false,
      show_manage_chart: false,
      currentPage: 1,
      perPage: 10,
      searchQuery: '',
      sortOption: 'upload_date',
      sortOptions: [
        { value: 'alphabet', text: '이름 순' },
        { value: 'upload_date', text: '업로드 순' }
      ],
      sortDirection: 'desc',
      previousSortOption: 'upload_date',
      duplicate_source: null
    };
  },
  watch: {
    chart_data: {
      immediate: true,
      handler() {
        this.setCurrentPage();
      }
    },
    selected_chart_list: {
      immediate: true,
      handler() {
        this.selected_checkbox_chart_list = this.selected_chart_list;
      }
    },
    perPage() {
      this.setCurrentPage();
    },
    selected_checkbox_chart_list: {
      handler() {
        this.setCurrentPage();
      },
      deep: true
    },
    searchQuery() {
      this.currentPage = 1;
    },
    sortOption() {
      this.currentPage = 1;
    },
    sortDirection() {
      this.currentPage = 1;
    }
  },
  computed: {
    ...mapState('charts', [
      'gri_linked_indicators',
      'sasb_linked_indicators',
      'tcfd_linked_indicators',
      'storyboard_linked_indicators'
    ]),
    ...mapState('report_list', ['report_code', 'standard_mode']),
    ...mapState('cursor', ['editing_gri_code']),
    ...mapState('charts', ['chart_data', 'chart_field', 'chart_linked_indicators']),
    ...mapGetters('story_board', ['selected_lv2']),

    sortedChartData() {
      const sortedList = [...this.chart_data];
      switch (this.sortOption) {
        case 'alphabet':
          sortedList.sort((a, b) => {
            return this.sortDirection === 'asc'
              ? a.title.localeCompare(b.title)
              : b.title.localeCompare(a.title);
          });
          break;
        case 'upload_date':
          sortedList.sort((a, b) => {
            const dateA = new Date(a.time_stamp);
            const dateB = new Date(b.time_stamp);
            return this.sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
          });
          break;
        default:
          break;
      }
      return sortedList;
    },

    filteredChartData() {
      if (!this.searchQuery) {
        return this.sortedChartData;
      }
      const searchLower = this.searchQuery.toLowerCase();
      return this.sortedChartData.filter(item => {
        const titleMatch = item.title?.toLowerCase().includes(searchLower);
        const timeStampMatch = item.time_stamp?.toLowerCase().includes(searchLower);

        const griMatch = this.gri_linked_indicators[item.chart_id]?.some(code =>
          code.toLowerCase().includes(searchLower)
        );
        const sasbMatch = this.sasb_linked_indicators[item.chart_id]?.some(code =>
          code.toLowerCase().includes(searchLower)
        );
        const tcfdMatch = this.tcfd_linked_indicators[item.chart_id]?.some(code =>
          code.toLowerCase().includes(searchLower)
        );
        const storyboardMatch = this.storyboard_linked_indicators[item.chart_id]?.some(
          indicator =>
            indicator.sb_toc_lv1.name.toLowerCase().includes(searchLower) ||
            indicator.sb_toc_lv2.name.toLowerCase().includes(searchLower)
        );

        return (
          titleMatch || timeStampMatch || griMatch || sasbMatch || tcfdMatch || storyboardMatch
        );
      });
    },

    paginatedChartData() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredChartData.slice(start, end);
    },
    // #801 복제 컬럼은 백엔드 fields에 없으므로 클라이언트에서 mng_chart 직전에 삽입한다.
    chart_field_with_duplicate() {
      const baseFields = Array.isArray(this.chart_field) ? [...this.chart_field] : [];
      if (baseFields.some(f => (f && (f.key || f)) === 'dup_chart')) {
        return baseFields;
      }
      const dupField = { key: 'dup_chart', label: '복제', class: 'text-center' };
      const mngIdx = baseFields.findIndex(f => (f && (f.key || f)) === 'mng_chart');
      if (mngIdx === -1) {
        baseFields.push(dupField);
      } else {
        baseFields.splice(mngIdx, 0, dupField);
      }
      return baseFields;
    }
  },
  beforeDestroy() {
    if (!this.editing_mode) {
      this.update_selected_chart_id(null);
      this.update_selected_chart_data(null);
    }
  },
  methods: {
    ...mapActions('story_board', ['addErtContent', 'updateErtContent']),
    ...mapActions('charts', [
      'saveAddChart',
      'updateDCIndicator',
      'updateChartIndicator',
      'getChartList',
      'getDCToC',
      'duplicateChart'
    ]),
    ...mapMutations('charts', ['update_selected_chart_id', 'update_selected_chart_data']),

    openDuplicateModal(item) {
      this.duplicate_source = item;
      const titles = (this.chart_data || []).map(c => c.label || c.title || '');
      const sourceName = item.label || item.title || '';
      const defaultTitle = nextDuplicateName(sourceName, titles);
      this.$nextTick(() => {
        this.$refs.duplicateModal.show(defaultTitle);
      });
    },
    validateDuplicateTitle(title) {
      const list = this.chart_data || [];
      const dup = list.find(
        c =>
          (c.title === title || c.label === title) && c.chart_id !== this.duplicate_source?.chart_id
      );
      if (dup) return '같은 이름의 차트가 이미 존재합니다.';
      return null;
    },
    async confirmDuplicate(new_title) {
      if (!this.duplicate_source) return;
      const source_id = this.duplicate_source.chart_id;
      this.$refs.duplicateModal.setLoading(true);
      try {
        const result = await this.duplicateChart({
          chart_id: source_id,
          new_title,
          report_code: this.report_code
        });
        if (result) {
          this.$refs.duplicateModal.hide();
          this.duplicate_source = null;
        }
      } finally {
        this.$refs.duplicateModal.setLoading(false);
      }
    },

    async initializeChartList() {
      try {
        if (!this.editing_mode) {
          await this.getChartList({
            report_code: this.report_code,
            is_editing: false
          });
          this.setCurrentPage();
        } else {
          this.selected_checkbox_chart_list = this.initial_checkbox_chart_list;
        }
      } catch (error) {
        this.$Sentry.captureException(error);
      }
    },

    setCurrentPage() {
      if (this.selected_radio_chart_id && this.chart_data.length > 0) {
        const chartIndex = this.chart_data.findIndex(
          chart => chart.chart_id === this.selected_radio_chart_id
        );
        if (chartIndex !== -1) {
          this.currentPage = Math.floor(chartIndex / this.perPage) + 1;
        }
      }
    },
    addOrEditChartCase() {
      this.update_selected_chart_id(null);
      this.update_selected_chart_data(null);

      if (this.editing_mode) {
        this.$emit('flag_modal_mode', 'chart_edit');
      } else {
        this.show_edit_chart = true;
        this.show_manage_chart = false;
        this.$refs['edit-chart-case'].show();
      }
    },
    editSelectedChart(payload) {
      this.show_edit_chart = true;
      this.show_manage_chart = false;
      this.update_selected_chart_id(payload.item.chart_id);
      this.update_selected_chart_data(payload.item.form);

      if (this.editing_mode) {
        this.$emit('flag_modal_mode', 'chart_edit');
      } else {
        this.$refs['edit-chart-case'].show();
      }
    },
    manageSelectedChart(payload) {
      this.show_edit_chart = false;
      this.show_manage_chart = true;

      this.update_selected_chart_id(payload.item.chart_id);
      this.update_selected_chart_data(payload.item.form);

      if (this.editing_mode) {
        this.$emit('flag_modal_mode', 'chart_manage');
      } else {
        this.$refs['edit-chart-case'].show();
      }
    },
    closeEditChartModal() {
      if (this.editing_mode) {
        this.selected_radio_chart_id = '';
        this.$emit('closeModal');
        this.selected_checkbox_chart_list = this.initial_checkbox_chart_list;
      } else {
        this.$refs['edit-chart-case'].hide();
      }

      this.show_edit_chart = false;
      this.show_manage_chart = false;
    },
    applyChartFromDC() {
      // Data center와 Web Site 내
      if (!this.selected_radio_chart_id) {
        window.alert('차트를 선택해주세요.');
        return;
      }

      if (this.dc_key_info.length > 0) {
        this.updateDCIndicator({
          report_code: this.report_code,
          type: 'chart',
          id: this.selected_radio_chart_id,
          payload: this.dc_key_info
        });
      } else {
        // 스토리보드 내 차트 저장
        if (this.sb_disclosure_id) {
          this.updateErtContent({
            disclosure_id: this.sb_disclosure_id,
            id: this.selected_radio_chart_id,
            type: 'chart'
          });
        } else {
          this.addErtContent({
            report_code: this.report_code,
            lv2_key: this.selected_lv2.key,
            id: this.selected_radio_chart_id,
            type: 'chart'
          });
        }
      }
      this.closeEditChartModal();
    },

    applyChart() {
      if (this.selected_checkbox_chart_list.length === 0) {
        window.alert('차트를 선택해주세요');
      } else {
        this.updateChartIndicator({
          report_code: this.report_code,
          type: this.standard_mode,
          editing_code: this.editing_gri_code,
          payload: this.selected_checkbox_chart_list
        });

        this.initial_checkbox_chart_list = this.selected_checkbox_chart_list;
        this.closeEditChartModal();
      }
    },
    handleSortChange(selectedOption) {
      if (selectedOption === this.previousSortOption) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.previousSortOption = selectedOption;
        this.sortDirection = 'asc';
      }
      this.sortOption = selectedOption;
      this.sortTable();
    },

    toggleSortDirection() {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      this.sortTable();
    },

    sortTable() {
      this.currentPage = 1;
    }
  },
  created() {
    this.initializeChartList();
    this.previousSortOption = this.sortOption;
  },
  mounted() {
    this.initializeChartList();
    this.$nextTick(() => {
      this.setCurrentPage();
    });
  }
};
</script>

<style scoped></style>
